import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class NotImplementedError extends CodedError {
  static get errorName() {
    return errorCodes.notImplementedError.code;
  }

  constructor(message: string = errorCodes.notImplementedError.message) {
    super(message);
    this.code = errorCodes.notImplementedError.code;
    this.message = `${message} ${errorCodes.notImplementedError.code}`;
    this.name = errorCodes.notImplementedError.name;
    this.status = errorCodes.notImplementedError.status;
  }
}
